import css from 'styled-jsx/css'

import { colors, sizes } from '../../theme'
import common from '../../theme/common'


export default css`
  .horizontal {
    display: block;
    margin-bottom: 2rem;
  }

  .text {
    ${common.h4}
    opacity: .4;
  }

  :global(.marquee-container) {
    overflow: hidden;
    gap: 3rem;
  }

  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
    .horizontal {
      margin-bottom: 0;
    }

    .horizontal :global(.overlay::before) {
      background: unset;
    }

    .horizontal :global(.overlay::after) {
      background: unset;
    }

    .text {
      ${common.t2}
    }
  }
`
